import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Radio,
  Tooltip,
  Checkbox,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { GlobalSet } from "../../pageStyled";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { addProduct, getProductsData } from "../../../Services/productServices";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import {
  getAllGrades,
  getGradeQualities,
  getGradeProductParameter,
} from "../../../Services/settingsServices";
import { useLocation, useNavigate } from "react-router";
import warning from "../../../Assets/Icons/warning.png";
import { capital_letter } from "../../../Utils/helper/helper";
import { getUnitData } from "../../../Services/measurementService";
import {
  currency_List,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices.js";

const { Option } = Select;
const gradeTypeData = [
  "Kraft Paper",
  "Duplex Paper",
  "Corrugated Paper",
  "Writing and Printing Paper",
];
const qualityTypeData = ["Copier Gold", "Kraft Paper", "Duplex Paper"];

const userStatusData = [
  { label: "Active", value: "active" },
  { label: "Disabled", value: "disabled" },
];

const { TextArea } = Input;

const AddNewProducts = (props) => {
  const location = useLocation();
  const [userStatus, setUserStatus] = useState(userStatusData[0].value);
  const [selectGradeType, setSelectGradeType] = useState();
  const [form] = Form.useForm();
  // const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [grades, setGrades] = useState([]);
  const [qualities, setQualities] = useState([]);
  const [isQualityDropdownOpen, setQualityDropdown] = useState(false);
  const [isGradeDropdownOpen, setGradeDropdown] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [productParam, setProductParam] = useState();
  const [unitData, setUnitData] = useState();
  const [checkboxCount, setCheckboxCount] = useState(
    // location.state?.action == "add" ? 4 : 0
    4
  );
  const [productTypes, setProductTypes] = useState("reel");
  const [selectedRange, setSelectedRange] = useState([]);
  const [switchFetchOrdersfromERP,setSwitchFetchOrdersfromERP] = useState(false);
  const [referenceCodes, setReferenceCodes] = useState([]);

  useEffect(()=>{
    (async()=>{
      const orderManagementSettings = await getWorkflowSettings("order_management");
      setSwitchFetchOrdersfromERP(orderManagementSettings?.data?.fetch_orders_from_erp?.value);
    })();
  },[])

  const checkboxes = Array.from({ length: checkboxCount }, (_, index) => (
    <Col span={6} key={index}>
      <Checkbox value={`${index + 1}`}>
        {" "}
        <span
          style={{
            color: "#323130",
            fontSize: "14px",
            fontFamily: "font-family: var(--sf-pro-text)",
            fontStyle: "normal",
          }}
        >
          {index + 1}
        </span>
      </Checkbox>
    </Col>
  ));
  const types = [
    { label: "Reel", value: "reel" },
    { label: "Sheet", value: "sheet" },
    { label: "Reel & Sheet", value: "both" },
  ];
  const routeBack = (action, response) => {
    navigate("../products-records/", {
      state: { action: action, response: response },
    });
  };
  const handleCheckboxChange = (checkedValues) => {
    setSelectedRange(checkedValues);
  };
  const modalShow = () => {
    setVisible(true);
  };

  const modalCancel = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    setVisible(false);
    routeBack();
  };

  const onChangeHandlerGradeBox = (value) => {
    setSelectGradeType(value);
  };

  const handleStatusChange = (e) => {
    setUserStatus(e.target.value);
  };

  const addProductHandler = () => {
    form.submit();
  };

  const onFinish = async (values) => {
    let productName = capital_letter(values.name.trim());
    const cleanedReferenceCodes = referenceCodes
    .map(code => code.trim()) // remove extra spaces
    .filter(code => code !== "");
    let body = {
      //code: values.code,
      // name: values.name.charAt(0).toUpperCase() + values.name.slice(1),
      name: productName,
      gsm: values.gsm,
      grade: values.grade,
      quality: values.quality,
      price: (switchFetchOrdersfromERP)?10000:values.price,
      status: values.status,
      remarks: values.remarks,
      bulk: parseFloat(values.bulk).toFixed(3),
      type: productTypes,
      ply: Array.isArray(values.ply_range) ? values.ply_range.map(Number) : switchFetchOrdersfromERP?[1]: [],
      units: { price: switchFetchOrdersfromERP?"INR":values.currency, per_weight_unit: switchFetchOrdersfromERP?"t":values.weight },
      reference_codes: cleanedReferenceCodes
    };

    if (values.burst_factor) {
      body["burst_factor"] = parseFloat(values.burst_factor).toFixed(2);
    }

    if (values.moisture) {
      body["moisture"] = parseFloat(values.moisture).toFixed(2);
    }

    try {
      const editPoResponse = await addProduct(body);
      // console.log(editPoResponse);
      const res = {
        error: editPoResponse.error,
        data: editPoResponse.data,
        msg: editPoResponse.msg,
      };
      routeBack("add", res);
      // if (!editPoResponse.error) {
      //   setSuccess(true);
      //   setTimeout(() => {
      //     setSuccess(false);
      //   }, 2000);
      // }
    } catch (error) {
      // setErrorMessage(error.response.data.msg);
      console.log(error);
      setError(true);
      // setTimeout(() => {
      //   setError(false);
      // }, 2000);

      if(error?.response?.status == 500){
        setErrorMessage("Something went wrong. Please try again");
      } else{
        setErrorMessage(error?.response?.data?.msg);
      }

      setTimeout(() => {
        setError(false);
      }, 2000);
    }
  };
  const OntoggleSelect = () => {
    setQualityDropdown((prevState) => !prevState);
  };
  const OnGradetoggleSelect = () => {
    setGradeDropdown((prevState) => !prevState);
  };

  const handleAddReferenceCode = () => {
    setReferenceCodes([...referenceCodes, ""]);
  };

  const handleReferenceCodeChange = (value, index) => {
    const updated = [...referenceCodes];
    updated[index] = value;
    setReferenceCodes(updated);

    form.setFieldsValue({[`ref_code${index}`]: value,});
  };

  const handleDeleteReferenceCode = (index) => {
    const updated = referenceCodes.filter((_, i) => i !== index);
    setReferenceCodes(updated);

    const currentValues = form.getFieldsValue();
    const newValues = {};

     if(updated?.length == 0){
      Object.keys(currentValues).forEach((key) => {
        if (key.startsWith("ref_code")) {
          newValues[key] = undefined;
        }
      });
    } else{
        updated.forEach((item, i) => {
        newValues[`ref_code${i}`] = item;
      });
    }

    form.setFieldsValue(newValues);
  };

  useEffect(() => {
    getAllGrades("enabled")
      .then((response) => {
        setGrades(response.map((grade) => grade.name));
        // console.log("Grades", grades);
      })
      .catch((error) => {
        console.log(error);
      });
    getProductsData("")
      .then((response) => {
        setProducts(response);
        // console.log("Grades", grades);
      })
      .catch((error) => {
        console.log(error);
      });
    getUnitData()
      .then((response) => {
        let data = response.data;
        let perWeight = [];
        for (
          let index = 0;
          index < data.units_management.weight.data.length;
          index++
        ) {
          const unit = data.units_management.weight.data[index];
          perWeight.push({
            value: unit,
            label: "Per " + weightUnit[unit].displayName,
          });
        }

        let filteredCurrency = currency_List.filter((item) =>
          data.units_management.currency.data.includes(item.code)
        );

        data.units_management.weight["perDeafultWeight"] =
          "Per " + weightUnit[data.units_management.weight.default].displayName;
        data.units_management.currency["currencyList"] = filteredCurrency;
        data.units_management.weight["perWeight"] = perWeight;
        setUnitData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    (async () => {
      form.setFieldsValue({ quality: "" });
      await getGradeQualities(encodeURIComponent(selectGradeType), "enabled")
        .then((response) => {
          setQualities(response.map((quality) => quality.name));
          console.log("qualities", response);
        })
        .catch((error) => {
          console.log(error);
        });

      await getGradeProductParameter(selectGradeType)
        .then((response) => {
          //setQualities(response.map((quality) => quality.name));
          console.log("qualities", response);
          setProductParam(response);
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, [selectGradeType]);

  useEffect(() => {
    setSelectedRange([]);
  }, [productTypes]);
  return grades && unitData ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          // onBack={() => window.history.back()}
          title="Add a new product"
          extra={[
            <Button key="3" className="textTypeBtn" onClick={modalShow}>
              Cancel changes
            </Button>,
            <Button
              key="2"
              className="themeBtn"
              onClick={() => addProductHandler()}
            >
              <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              Add Product
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      The general details of the product will be used in reports
                      and order records
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  {/* <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product Code</label>
                        <p>This is an auto generated code</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="code"
                          //rules={[{ required: true }]}
                          className=""
                          placeholder="Auto generated machine code"
                        >
                          <Input disabled />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row> */}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product Name</label>
                        <p>
                          The product will be identified by this unique name
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              max: 50,
                              message:
                                "Name can have a maximum of 50 characters",
                            },
                            {
                              validator(_, value) {
                                if (
                                  value == null ||
                                  !products.filter(
                                    (data) =>
                                      data.name.toUpperCase() ===
                                      value.toUpperCase()
                                  ).length
                                ) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(
                                    "This name exists for another product"
                                  );
                                }
                              },
                            },
                          ]}
                          className=""
                        >
                          <Input
                            placeholder="Enter name of the Product"
                            style={{ textTransform: "capitalize" }}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>

                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product Reference Codes <span>(Optional)</span></label>
                        <p>The product can have multiple reference codes</p>
                      </div>
                    </Col>

                    <Col span={12}>
                      <div className="boxFormType">

                        {/* Render Existing Codes */}
                        {referenceCodes.map((code, index) => (
                          <Row
                            key={index+1}
                            gutter={8}
                            align="middle"
                            style={{ marginBottom: 8 }}
                          >
                            <Col flex="auto">
                            <Form.Item
                              name={`ref_code${index}`}
                              rules={[
                                    {
                                    pattern: /^[a-zA-Z0-9 ]+$/,
                                    message: "Reference Code can be only alphanumeric!",
                                  },
                                ]}
                              className=""
                            >
                            <Input
                                placeholder="Enter reference code"
                                value={code}
                                maxLength={30}
                                onChange={(e) =>
                                  handleReferenceCodeChange(e.target.value, index)
                                }
                              />
                          </Form.Item>
                            </Col>

                            <Col>
                              <Button
                                type="text"
                                danger
                                onClick={() => handleDeleteReferenceCode(index)}
                                icon={<Iconmoon icon="delete" size={16} />}
                              />
                            </Col>
                          </Row>
                        ))}

                        <Row justify="end">
                          <Button
                            className="themeBtn noBg"
                            onClick={handleAddReferenceCode}
                          >
                            <Iconmoon icon="addcircle" size={16} color="#EA655B" />{" "}
                            Add
                          </Button>
                        </Row>

                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Product Specifications</h2>
                    <p>
                      The product specification will be used to identify a
                      product and will be used in deckle matching process
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Grade</label>
                        <p>Grade of the Product</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="grade"
                          rules={[
                            {
                              required: true,
                              message: "Please select a grade",
                            },
                          ]}
                        >
                          <Select
                            suffixIcon={
                              isGradeDropdownOpen ? (
                                <DropDownSearchDraw />
                              ) : (
                                <DownArrowDraw />
                              )
                            }
                            onBlur={OnGradetoggleSelect}
                            onFocus={OnGradetoggleSelect}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            placeholder={"Select a grade"}
                            onChange={onChangeHandlerGradeBox}
                          >
                            {grades.map((grade) => (
                              <Option key={grade}>{grade}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>GSM</label>
                        <p>GSM of the product</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="gsm"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                              message:
                                "Only numeric characters are allowed upto 3 decimal points",
                            },
                          ]}
                          className=""
                        >
                          <Input placeholder="Enter GSM of the product" />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  {productParam?.product?.burst_factor && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Burst Factor</label>
                          <p>Burst factor of the product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="burst_factor"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                message: "Only numeric characters are allowed",
                              },
                            ]}
                            className=""
                          >
                            <Input placeholder="Enter Burst Factor of the product" />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  )}
                  {productParam && !productParam.product && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Burst Factor</label>
                          <p>Burst factor of the product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="burst_factor"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                message: "Only numeric characters are allowed",
                              },
                            ]}
                            className=""
                          >
                            <Input placeholder="Enter Burst Factor of the product" />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Bulk</label>
                        <p>Bulk of the product</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="bulk"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                              message:
                                "Only numeric characters are allowed upto 3 decimal points",
                            },
                          ]}
                          className=""
                        >
                          <Input placeholder="Enter bulk of the product" />
                        </Form.Item>
                        <span className="nonEditable">c.c./gm</span>
                      </div>
                    </Col>
                  </Row>
                  {productParam?.product?.moisture && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Moisture</label>
                          <p>Moisture of the product</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="moisture"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                message: "Only numeric characters are allowed",
                              },
                            ]}
                            className=""
                          >
                            <Input placeholder="Enter moisture of the product" />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Quality</label>
                        <p>Quality of the product</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        {/* The list of qualities will be fetched from configuration global settings */}
                        <Form.Item
                          name="quality"
                          rules={[
                            {
                              required: true && qualities.length !== 0,
                              message: "Please select a quality",
                            },
                          ]}
                        >
                          <Select
                            suffixIcon={
                              isQualityDropdownOpen ? (
                                <DropDownSearchDraw />
                              ) : (
                                <DownArrowDraw />
                              )
                            }
                            onBlur={OntoggleSelect}
                            onFocus={OntoggleSelect}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            placeholder={"Select a quality"}
                            disabled={!selectGradeType}
                          >
                            {qualities.map((qualityType) => (
                              <Option key={qualityType}>{qualityType}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Price</label>
                        <p>Price of the product per weight</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign ">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="currency"
                              initialValue={
                                unitData.units_management.currency.default
                              }
                            >
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                showSearch
                              >
                                {unitData.units_management.currency.currencyList.map(
                                  (currency) => (
                                    <Option key={currency.code}>
                                      <Tooltip title={currency.displayName}>
                                        {`${currency.code}`}
                                      </Tooltip>
                                    </Option>
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="price"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^\d+(\.\d{1,3})?$|^\.\d{1,3}$/,
                                  message:
                                    "Only decimal characters upto 3 decimal places are allowed",
                                },
                              ]}
                              className=""
                            >
                              <Input placeholder="Enter price of product in Price/Ton" />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType "
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="weight"
                              initialValue={
                                unitData.units_management.weight.default
                              }
                            >
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                showSearch
                              >
                                {unitData.units_management.weight.perWeight.map(
                                  (weight) => (
                                    <Option key={weight.value}>
                                      {`${weight.label}`}
                                    </Option>
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product type</label>
                        <p>The product can be of reel or sheet type</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="type"
                          rules={[
                            {
                              required: !switchFetchOrdersfromERP,
                              message: "This field is required",
                            },
                          ]}
                          className="selectForm"
                          initialValue={types.length ? types[0]["label"] : null}
                        >
                          <Select
                            placeholder="Select"
                            suffixIcon={<DownArrowDraw />}
                            onChange={(value) => {
                              setProductTypes(value);
                              if (value === "sheet") {
                                setSelectedRange([1]);
                                form.setFieldsValue({ ply_range: [1] }); //
                              } else {
                                setSelectedRange([]);
                                form.setFieldsValue({ ply_range: [] });
                              }
                            }}
                          >
                            {types.map((orderType) => (
                              <Option key={orderType.value}>
                                {orderType.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Ply Range</label>
                        <p>Ply count that can be processed by this product</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="ply_range"
                          rules={[
                            {
                              required: !switchFetchOrdersfromERP,
                              message: "This field is required",
                            },
                          ]}
                        >
                          {productTypes === "sheet" ? (
                            // bind value manually via hidden field
                            <>
                              <Checkbox checked disabled>
                                <span
                                  style={{
                                    color: "#323130",
                                    fontSize: "14px",
                                    fontFamily: "var(--sf-pro-text)",
                                    fontStyle: "normal",
                                  }}
                                >
                                  1
                                </span>
                              </Checkbox>
                              <Input type="hidden" value={1} />
                            </>
                          ) : (
                            <Checkbox.Group
                              value={selectedRange}
                              onChange={(checkedValues) => {
                                setSelectedRange(checkedValues);
                                form.setFieldsValue({
                                  ply_range: checkedValues,
                                });
                              }}
                              style={{ width: "100%" }}
                            >
                              <Row gutter={16}>{checkboxes}</Row>
                            </Checkbox.Group>
                          )}
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All Other information related to this product</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Status</label>
                        <p>
                          The order for this product will only be recorded if
                          it's enabled
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="status"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue="active"
                        >
                          <Radio.Group
                            options={userStatusData}
                            onChange={handleStatusChange}
                            value={userStatus}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Remarks <span>(Optional)</span>
                        </label>
                        <p>Extra information of this product</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Form.Item
                            name="remarks"
                            rules={[
                              {
                                max: 70,
                                message:
                                  "Remarks can have a maximum of 70 characters",
                              },
                            ]}
                            className=""
                          >
                            <TextArea maxLength={100} style={{ height: 90 }} />
                          </Form.Item>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>

      <ConfirmationModal
        visible={visible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalConfirm}
      >
        <span>Are you sure?</span>
        <p>
          You have pending changes on this page, are you sure you want to leave?
        </p>
      </ConfirmationModal>

      {/* {success && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg="Product added successfully"
        />
      )} */}
      {error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={errorMessage}
        />
      )}
    </RightLayoutContainer>
  ) : (
    <></>
  );
};

export default AddNewProducts;